import { PensionPlanTransfer } from '../api/pension-plan-transfers/interfaces/PensionPlanTransfer';

export interface TransferProjectionInputs {
	/** Saldo que traspasa (€). */
	balance: number;
	/** Aportación mensual (€). */
	monthlyContribution: number;
	/** Años hasta la jubilación, enteros y en [1, 47] como el slider del informe. */
	years: number;
}

const positivo = (v: unknown): number | null => {
	const n = Number(v);
	return Number.isFinite(n) && n > 0 ? n : null;
};

/**
 * Datos de la proyección de un traspaso, sacados del propio traspaso con los mismos criterios
 * que el informe de la exploración (chirigota#576): la aportación que guardó en el informe o, si
 * no, la del onboarding (0 € si ninguna: puede tener saldo sin aportar); los años del onboarding
 * o, si no, 67 − edad.
 */
export function transferProjectionInputs(
	transfer: PensionPlanTransfer,
	currentAge: number
): TransferProjectionInputs {
	const metadata = (transfer.metadata ?? {}) as Record<string, unknown>;
	const balance = positivo(transfer.amount) ?? 0;
	const monthlyContribution =
		positivo(metadata.monthlyContribution) ?? positivo(metadata.monthly_contribution) ?? 0;
	const rawYears = positivo(metadata.years_to_retirement) ?? 67 - currentAge;
	const years = Math.min(47, Math.max(1, Math.round(rawYears)));
	return { balance, monthlyContribution, years };
}
